module.exports = __webpack_public_path__ + "f1fd3c5392655678bcb70611826d4c70.mp3";